import { getCurrentOrg } from '.';
import { AgentApiService } from '../services/agents-management';
import type {
  AgentPromptDto,
  CreateAgentPromptRequest,
  UpdateAgentPromptRequest,
} from '../services/agents-management';

export type {
  AgentPromptDto,
  CreateAgentPromptRequest,
  UpdateAgentPromptRequest,
};

type AgentPrompt = AgentPromptDto;
type CreateAgentPrompt = CreateAgentPromptRequest;
type UpdateAgentPrompt = UpdateAgentPromptRequest;

export const getAgentPrompts = (agentId: string): Promise<AgentPrompt[]> => {
  return AgentApiService.getAgentPrompts(getCurrentOrg(), agentId);
};

export const createAgentPrompt = (
  agentId: string,
  payload: CreateAgentPrompt
): Promise<AgentPromptDto> => {
  return AgentApiService.createAgentPrompt(getCurrentOrg(), agentId, payload);
};

export const updateAgentPrompt = (
  agentId: string,
  promptId: string,
  payload: UpdateAgentPrompt
): Promise<AgentPromptDto> => {
  return AgentApiService.updateAgentPrompt(
    getCurrentOrg(),
    agentId,
    promptId,
    payload
  );
};

export const deleteAgentPrompt = (
  agentId: string,
  promptId: string
): Promise<void> => {
  return AgentApiService.deleteAgentPrompt(getCurrentOrg(), agentId, promptId);
};
